import { DownloadExcelTemplateApi } from "@/features/accounts/csv-excel/services/download-template-api";
import { DownloadTemplateRequestModel } from "@/features/accounts/csv-excel/services/download-template-model";

/// Excel雛形取得処理
export class DownloadExcelTemplateService {
  private downloadExcelTemplateApi = new DownloadExcelTemplateApi();

  /**
   * Excel雛形取得API実行
   */
  public async downloadExcelTemplate(param: DownloadTemplateRequestModel) {
    return await this.downloadExcelTemplateApi.downloadExcelTemplate(param);
  }
}
